import { Col, Container, Row } from "react-grid-system";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import _, { get, isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
    BaseBreadcrumb,
    Content,
    BaseButton,
    BaseSelect,
    BaseTable,
    Flex,
    ContentLoader,
} from "components";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllCbmList } from "app/slices/managementSlices/cbmSlice/cbmSlice";
import { NumericFormat } from "react-number-format";
import { ManagementApiService } from "services/apiServices";
import { toast } from "react-toastify";

const CbmContainer = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const managementOperators = useSelector((store) =>
        get(store, "management.cbmSlice.data.cbmList", [])
    );
    const isFetched = get(managementOperators, "success", false);
    const { data } = managementOperators

    const [filter, setFilter] = useState({
        page: "", search: "", id: ''
    })

    const handleSearch = () => {
         dispatch(fetchAllCbmList(filter))
    }

    const handleDownload = async () => {
        toast.loading("Загрузка")
        try {
            const res = await ManagementApiService.CbmDownload();
            if (res.data.data) {
                toast.dismiss()
                toast.success("Загрузка прошла успешно")
            }
            const excelData = res.data.data.map(({ code, country, region, weight, cbm }) => ({
                code,
                country,
                region,
                weight,
                cbm
            }));

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Shipping Data");

            // Define headers
            worksheet.columns = [
                { header: "Почта Код", key: "code", width: 20 },
                { header: "Страна", key: "country", width: 15 },
                { header: "Регион", key: "region", width: 20 },
                { header: "Вес", key: "weight", width: 10 },
                { header: "CBM", key: "cbm", width: 10 },
            ];

            // Add fetched data
            excelData.forEach((item) => worksheet.addRow(item));

            // Save file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "shipping-data.xlsx");
        } catch (error) {
            toast.dismiss()
            toast.success("⚠️ Ошибка при загрузке данных")
            console.error("Failed to download Excel:", error);
            alert("⚠️ Ошибка при загрузке данных");
        }
    };
    useEffect(() => {
        dispatch(fetchAllCbmList(filter))

    }, [filter.page, filter.id]);
    useEffect(() => {
        dispatch(fetchAllCbmList(filter))
    }, [])
    return (
        <Container fluid>
            <Row>
                <Col xs={12} className={"mb-8"}>
                    <BaseBreadcrumb
                        items={[
                            { id: 1, name: "Менеджмент", url: "/management" },
                            {
                                id: 2,
                                name: "CBM",
                                url: "/management/cbm",
                            },
                        ]}
                    />
                </Col>
                <Col xs={12}>
                    <Content>
                        <Row>
                            <Col xs={12} className={"mb-16"}>
                                <Row align={"center"}>
                                    <Col xs={8}>
                                        <Flex justify={"flex-start"}>
                                            <BaseSelect
                                                handleChange={(e) => {
                                                    setFilter((filter) => ({
                                                        ...filter,
                                                        id: e,
                                                    }))
                                                }}
                                                defaultValue={' '}
                                                options={[
                                                    {
                                                        label: "Super Admin",
                                                        value: 1
                                                    },
                                                    {
                                                        label: "Dealer",
                                                        value: 2,

                                                    },
                                                    {
                                                        label: "All",
                                                        value: ' '
                                                    },
                                                ]}
                                                margin={"0 12px 0 12px"}
                                                width={"180px"}
                                                placeholder="All"
                                            />
                                        </Flex>
                                    </Col>
                                    <Col xs={4} className={"text-right"}>
                                        <Flex justify={"flex-end"}>
                                            <BaseButton
                                                primary
                                                handleClick={() => handleSearch()}
                                            >
                                                Поиск
                                            </BaseButton>
                                            <BaseButton

                                                margin={"0 12px 0 12px"}
                                                green
                                                handleClick={() => handleDownload()}
                                            >
                                                Выгрузка Excel
                                            </BaseButton>
                                        </Flex>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={"mb-32"}>
                                {isFetched ? (
                                    <BaseTable
                                        tableHeader={[
                                            "ID",
                                            "Размер",
                                            "К-во",
                                            "CBM одна коробка",
                                            "Total CBM",
                                            "Total KG",
                                        ]}
                                    >
                                        {!isEmpty(data) ? (
                                            data.map((item, index) => (
                                                <tr key={index + 1}>
                                                    <td> {index + 1} </td>
                                                    <td> {get(item, "length", null)} х {get(item, "width", null)} х {get(item, "height", null)} </td>
                                                    <td> {get(item, "kol", null)} </td>
                                                    <td> {get(item, "cbm", null)} </td>
                                                    <td> {get(item, "totalCbm", null)} </td>
                                                    <td>{get(item, "totalWeight", null)}</td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={10}>No data</td>
                                            </tr>
                                        )}
                                        {!isEmpty(data) ? (
                                            <tr>
                                                <td
                                                    className="text-center"
                                                >
                                                    {" "}
                                                    Итого:{" "}
                                                </td>
                                                <td >
                                                    ***
                                                </td>
                                                <td >
                                                    <NumericFormat
                                                        displayType="text"
                                                        value={data.reduce(
                                                            (accumulator, currentValue) => accumulator + +currentValue.kol,
                                                            0
                                                        )}
                                                        thousandSeparator={true}
                                                        decimalScale={0}
                                                        fixedDecimalScale={true}
                                                    />{" "}
                                                </td>
                                                <td >
                                                    {/* <NumericFormat
                                                        displayType="text"
                                                        value={data.reduce(
                                                            (accumulator, currentValue) => accumulator + currentValue.cbm,
                                                            0
                                                        )}
                                                        thousandSeparator={true}
                                                        decimalScale={0}
                                                        fixedDecimalScale={true}
                                                    />{" "} */}
                                                    {
                                                        data.reduce(
                                                            (accumulator, currentValue) => accumulator + currentValue.cbm,
                                                            0
                                                        )
                                                    }
                                                </td>
                                                <td >
                                                    {/* <NumericFormat
                                                        displayType="text"
                                                        value={data.reduce(
                                                            (accumulator, currentValue) => accumulator + +currentValue.totalCbm,
                                                            0
                                                        )}
                                                        thousandSeparator={false}
                                                        decimalScale={0}
                                                        fixedDecimalScale={false}
                                                    />{" "} */}
                                                    {
                                                        data.reduce(
                                                            (accumulator, currentValue) => accumulator + currentValue.totalCbm,
                                                            0
                                                        )
                                                    }
                                                </td>
                                                <td >
                                                    <NumericFormat
                                                        displayType="text"
                                                        value={data.reduce(
                                                            (accumulator, currentValue) => accumulator + currentValue.totalWeight,
                                                            0
                                                        )}
                                                        thousandSeparator={false}
                                                        decimalScale={0}
                                                        fixedDecimalScale={false}
                                                    />{" "}
                                                </td>
                                            </tr>
                                        ) : (
                                            <></>
                                        )}
                                    </BaseTable>
                                ) : (
                                    <ContentLoader />
                                )}
                            </Col>
                        </Row>
                    </Content>
                </Col>
            </Row>
        </Container>
    )
}
export default CbmContainer